import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OcrPreviewComponent } from './ocr-preview.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { IconButtonModule } from '../../directives/icon-button/icon-button.module';



@NgModule({
  declarations: [
    OcrPreviewComponent
  ],
  exports: [
    OcrPreviewComponent
  ],
  imports: [
    CommonModule,
    PerfectScrollbarModule,
    IconButtonModule
  ]
})
export class OcrPreviewModule { }
